/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/** *************************************************************************************************
 * BROWSER POLYFILLS
 */

// Angular 17 has different polyfill requirements
// Many of these core-js polyfills are now included automatically or are no longer needed

/** Evergreen browsers require these. * */
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
// import 'core-js/es/reflect';

// A minimal polyfill for Element.closest() and Element.matches(),
// using MDN's implementation. Mostly meant for Microsoft IE9+.
import 'element-closest-polyfill';

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/** *************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
// For Angular 17, we need to import the complete zone.js package
import 'zone.js';
import 'zone.js/plugins/zone-error'; // Add explicit error handling for tests
// Included with Angular CLI.

/** *************************************************************************************************
 * APPLICATION IMPORTS
 */

// hammer is required for slider gestures
import 'hammerjs';

/** smoothscrolling for safari */
import smoothscroll from 'smoothscroll-polyfill';

// safari doesn't handle webrtc correctly, which breaks safari
// the event callbacks have an incorrect _this_ context, see:
// * https://bugs.webkit.org/show_bug.cgi?id=175802
// * https://github.com/angular/zone.js/issues/883
// eslint-disable-next-line import/extensions
import 'zone.js/plugins/webapis-rtc-peer-connection';

smoothscroll.polyfill();

// Some third-party browser bundles assume Node-style globals exist.
(window as any).global = window;

// Some third-party browser bundles assume `process.env` exists.
(window as any).process = { env: { NODE_DEBUG: undefined } };

// Additional Angular 17 test compatibility fixes
(window as any).global = window;
(window as any).__Zone_disable_timers = false;
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['message'];
